import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { chgInstance } from "../../redux/ReduxInstance";
import { Container, Form, Table, Button } from "react-bootstrap";
import { MdDeleteOutline, MdAddCircleOutline } from "react-icons/md";
import ComponentMenu from "../../components/layout/ComponentMenu";
import ComponentTitle from "../../components/layout/ComponentTitle";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { apiGetInstance, apiUpdateInstance } from "../../api/ApiInstance";
import { useTranslation } from "react-i18next";

const PageAdminDroitsAdministration = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const dispatch = useDispatch();
  const [state, setState] = useState({
    adminColideeAccess: [],
    adminProcessAccess: [],
    adminStatAccess: [],
  });
  const [loader, setLoader] = useState(false);
  const [reload, setReload] = useState(false);

  const handleAdd = (cle) => {
    const { adminColideeAccess, adminProcessAccess, adminStatAccess } = state;
    if (cle === "adminColideeAccess") {
      const newEmail = [...state.adminColideeAccess];
      newEmail.push("collaborateur_" + adminColideeAccess.length + "@domaine.com");
      setState({ ...state, adminColideeAccess: newEmail });
    }
    if (cle === "adminProcessAccess") {
      const newEmail = [...state.adminProcessAccess];
      newEmail.push("collaborateur_" + adminProcessAccess.length + "@domaine.com");
      setState({ ...state, adminProcessAccess: newEmail });
    }
    if (cle === "adminStatAccess") {
      const newEmail = [...state.adminStatAccess];
      newEmail.push("collaborateur_" + adminStatAccess.length + "@domaine.com");
      setState({ ...state, adminStatAccess: newEmail });
    }
  };

  const handleChange = (cle, indexTableau, newValeur) => {
    if (cle === "adminColideeAccess") {
      const stateCopy = [...state.adminColideeAccess];
      stateCopy[indexTableau] = newValeur;
      setState({ ...state, adminColideeAccess: stateCopy });
    }
    if (cle === "adminProcessAccess") {
      const stateCopy = [...state.adminProcessAccess];
      stateCopy[indexTableau] = newValeur;
      setState({ ...state, adminProcessAccess: stateCopy });
    }
    if (cle === "adminStatAccess") {
      const stateCopy = [...state.adminStatAccess];
      stateCopy[indexTableau] = newValeur;
      setState({ ...state, adminStatAccess: stateCopy });
    }
  };

  const handleDelete = (cle, indexTableau) => {
    if (cle === "adminColideeAccess") {
      const stateCopy = [...state.adminColideeAccess];
      stateCopy.splice(indexTableau, 1);
      setState({ ...state, adminColideeAccess: stateCopy });
    }
    if (cle === "adminProcessAccess") {
      const stateCopy = [...state.adminProcessAccess];
      stateCopy.splice(indexTableau, 1);
      setState({ ...state, adminProcessAccess: stateCopy });
    }
    if (cle === "adminStatAccess") {
      const stateCopy = [...state.adminStatAccess];
      stateCopy.splice(indexTableau, 1);
      setState({ ...state, adminStatAccess: stateCopy });
    }
  };

  const submitData = async (e) => {
    setLoader(true);
    e.preventDefault();
    await apiUpdateInstance(ReduxInstance._id, state);
    const res = await apiGetInstance(ReduxInstance._id, ReduxUserEmail);
    dispatch(chgInstance(res.data));
    setReload(!reload);
    setLoader(false);
  };

  useEffect(() => {
    const adminColideeAccess = ReduxInstance.adminColideeAccess
      .filter((x, i, a) => a.indexOf(x) === i)
      .sort();

    const adminProcessAccess = ReduxInstance.adminProcessAccess
      .filter((x, i, a) => a.indexOf(x) === i)
      .sort();

    const adminStatAccess = ReduxInstance.adminStatAccess
      .filter((x, i, a) => a.indexOf(x) === i)
      .sort();
    setState({
      adminColideeAccess: adminColideeAccess,
      adminProcessAccess: adminProcessAccess,
      adminStatAccess: adminStatAccess,
    });
  }, [reload]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <ComponentMenu />
      <Container>
        <Form onSubmit={submitData}>
          <ComponentTitle title={t("admin.PageAdminDroitsAdministration.titre")} />
          <Table responsive striped bordered hover className="stickyTable mt-2">
            <thead>
              <tr className="text-center">
                <th>{t("admin.PageAdminDroitsAdministration.titreColonne1")}</th>
                <th>{t("admin.PageAdminDroitsAdministration.titreColonne2")}</th>
                <th>{t("admin.PageAdminDroitsAdministration.titreColonne3")}</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <span role="button" onClick={(e) => handleAdd("adminColideeAccess")}>
                    <MdAddCircleOutline size="1.5em" />
                    {t("admin.PageAdminDroitsAdministration.buttonAjouterEmail")}
                  </span>
                </td>
                <td>
                  <span role="button" onClick={(e) => handleAdd("adminProcessAccess")}>
                    <MdAddCircleOutline size="1.5em" />
                    {t("admin.PageAdminDroitsAdministration.buttonAjouterEmail")}
                  </span>
                </td>
                <td>
                  <span role="button" onClick={(e) => handleAdd("adminStatAccess")}>
                    <MdAddCircleOutline size="1.5em" />
                    {t("admin.PageAdminDroitsAdministration.buttonAjouterEmail")}
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  {state.adminColideeAccess.map((email, index) => (
                    <div className="input-group mt-2 mb-2" key={"colidee_" + index}>
                      <MdDeleteOutline
                        className="mt-2 me-2"
                        size="1.5em"
                        role="button"
                        onClick={() => handleDelete("adminColideeAccess", index)}
                      />
                      <Form.Control
                        type="text"
                        name="adminColideeAccess"
                        value={email}
                        onChange={(e) => handleChange(e.target.name, index, e.target.value)}
                      />
                    </div>
                  ))}
                </td>
                <td>
                  {state.adminProcessAccess.map((email, index) => (
                    <div className="input-group mt-2 mb-2" key={"process_" + index}>
                      <MdDeleteOutline
                        className="mt-2 me-2"
                        size="1.5em"
                        role="button"
                        onClick={() => handleDelete("adminProcessAccess", index)}
                      />
                      <Form.Control
                        type="text"
                        name="adminProcessAccess"
                        value={email}
                        onChange={(e) => handleChange(e.target.name, index, e.target.value)}
                      />
                    </div>
                  ))}
                </td>
                <td>
                  {state.adminStatAccess.map((email, index) => (
                    <div className="input-group mt-2 mb-2" key={"stats_" + index}>
                      <MdDeleteOutline
                        className="mt-2 me-2"
                        size="1.5em"
                        role="button"
                        onClick={() => handleDelete("adminStatAccess", index)}
                      />
                      <Form.Control
                        type="text"
                        name="adminStatAccess"
                        value={email}
                        onChange={(e) => handleChange(e.target.name, index, e.target.value)}
                      />
                    </div>
                  ))}
                </td>
              </tr>
            </tbody>
          </Table>

          <div className="text-end mb-5">
            {!loader && (
              <Button variant="success" type="Submit">
                {t("commun.form.button.enregistrer")}
              </Button>
            )}
            {loader && <ComponentLoader />}
          </div>
        </Form>
      </Container>
    </>
  );
};

export default PageAdminDroitsAdministration;
